module.exports = __webpack_public_path__ + "img/blue-bubble-like-button-icon-thumbs-up-like-sign-feedback-concept-white-background-3d-rendering 1.ac51109.png";